// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ja[data-v-3dc576eb]{display:flex;justify-content:center;align-items:center;position:relative;width:100%;height:116px;z-index:1;position:-webkit-sticky;position:sticky;bottom:0}.ja__button[data-v-3dc576eb]{width:272px}", ""]);
// Exports
module.exports = exports;
